module.exports = __webpack_public_path__ + "img/abstract-shapes-6.15c03899.svg";